import PropTypes from 'prop-types';
import Text from '../../assets/styles/Text';
import * as styles from './styles';

export default function Title({
  title,
  subtitle = null,
  small = false,
  two = false,
}) {
  return (
    <styles.Container $small={small}>
      {two && <Text.H3>{subtitle}</Text.H3>}
      <Text.H1>{title}</Text.H1>

      {!two && subtitle && <Text.H3>{subtitle}</Text.H3>}
    </styles.Container>
  );
}

Title.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  small: PropTypes.bool,
  two: PropTypes.bool,
};
